import { FC } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { useStyles } from './styles';
import logoCircular from '../../../../assets/img/logo-circulo-white.png';

interface Props {
    onCancel: () => void;
    submitForm: () => void;
}

const PublishEventHeader: FC<Props> = ({ submitForm, onCancel }) => {
    const classes = useStyles();

    return (
        <Grid container direction="column" className={classes.container}>
            <Grid container item direction="row" justify="space-between">
                <Grid item className={classes.logoAndTitle}>
                    <img className={clsx(classes.logo)} src={logoCircular} alt="Logo" />
                    <Typography className={classes.pageTitle}>Publish Live Event</Typography>
                </Grid>

                <Grid item>
                    <Button
                        className={clsx(classes.cancelOrPublishButton, classes.cancelButton)}
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                    <Button
                        className={clsx(classes.cancelOrPublishButton, classes.publishButton)}
                        onClick={submitForm}
                    >
                        Publish
                    </Button>
                </Grid>
            </Grid>

            <Grid container item direction="row" justify="center">
                <Button className={classes.eventInfoButton}>Live event information</Button>
            </Grid>
        </Grid>
    );
};

export default PublishEventHeader;
